/**
 * ZoomToGeo widget-local constants.
 */

export const defaultNls = {
  title: "Region Auswahl",
  source: "Datenquelle auswählen",
  entity: "Region auswählen",
  zoomToSelectedLayer: "Auf Auswahl Zoomen",
  clear: "Auswahl zurücksetzen",
  loadingServices: "Dienste werden geladen...",
  loadingItems: "Einträge werden geladen...",
  errorLoadingServices: "Fehler beim Laden der Dienste",
  errorLoadingItems: "Fehler beim Laden der Einträge",
  errorLoadingGeometry: "Fehler beim Laden der Geometrie",
  tooLittle: "Für die gewählte Region liegen keine Zukunftsdaten vor.",
};

export const messageIds = {
  services: "regionalSelectionServices",
  servicesLoading: "regionalSelectionServicesLoading",
  servicesError: "regionalSelectionServicesError",
  selectionGraphic: "selectionGraphic",
};

export const selectionFrom = {
  urlParams: "urlParams",
  zoomToGeo: "zoomToGeo",
};

export const normalize = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();
